module.exports = __webpack_public_path__ + "static/media/6122fcf8-d63d-4446-a478-ca264638a415_1.51da6552ce7f5a253e1c9e51bcae4a72.61818403.jpeg";